/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_Totp_TotpEnrollmentQrResponseDto } from '../models/Wealthlane_Dtos_Totp_TotpEnrollmentQrResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';
import type { WealthlaneDtos_Totps_TotpEnrollmentIsAuthenticatorDeviceRegisteredResponseDto } from '../models/WealthlaneDtos_Totps_TotpEnrollmentIsAuthenticatorDeviceRegisteredResponseDto';
import type { WealthlaneDtos_Totps_TotpEnrollmentResponseDto } from '../models/WealthlaneDtos_Totps_TotpEnrollmentResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TotpEnrollmentService {

    /**
     * @returns Wealthlane_Dtos_Totp_TotpEnrollmentQrResponseDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiTotpEnrollmentQrCode(): CancelablePromise<Wealthlane_Dtos_Totp_TotpEnrollmentQrResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/totp/enrollment/qr-code',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns WealthlaneDtos_Totps_TotpEnrollmentResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiTotpEnrollmentVerify(
formData?: {
Code?: string;
},
): CancelablePromise<WealthlaneDtos_Totps_TotpEnrollmentResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/totp/enrollment/verify',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns WealthlaneDtos_Totps_TotpEnrollmentIsAuthenticatorDeviceRegisteredResponseDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiTotpEnrollmentIsAuthenticatorDeviceRegistered(): CancelablePromise<WealthlaneDtos_Totps_TotpEnrollmentIsAuthenticatorDeviceRegisteredResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/totp/enrollment/is-authenticator-device-registered',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiIdentityApiTotpEnrollmentRemoveAuthenticatorDevice(): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/identity/api/totp/enrollment/remove-authenticator-device',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
